import { supabase } from "@/integrations/supabase/client";

export type DocCollection = "sop" | "faq";

export type DocPathInfo = { collection: DocCollection; slug: string | null };

let cache: Record<string, DocPathInfo> | null = null;
let pending: Promise<Record<string, DocPathInfo>> | null = null;

export function loadDocCollections(): Promise<Record<string, DocPathInfo>> {
  if (cache) return Promise.resolve(cache);
  if (!pending) {
    pending = (async () => {
      const { data } = await supabase
        .from("sop_documents" as any)
        .select("doc_id,collection,slug")
        .eq("status", "published");
      const map: Record<string, DocPathInfo> = {};
      for (const r of (data as any[]) || []) {
        map[r.doc_id] = {
          collection: (r.collection === "faq" ? "faq" : "sop") as DocCollection,
          slug: (r.slug as string | null) || null,
        };
      }
      cache = map;
      return map;
    })();
  }
  return pending;
}

export function invalidateDocCollections() {
  cache = null;
  pending = null;
}

/**
 * Build the canonical member URL for a doc. Prefers slug; falls back to doc_id.
 * Every published document lives under a single /support/library/* path,
 * regardless of collection. The dictionary has a fixed sibling route.
 */
export function docHref(row: {
  collection?: string | null;
  doc_id: string;
  slug?: string | null;
}): string {
  if (row.collection === "faq" && row.doc_id === "FAQ-000") {
    return "/support/library/dictionary";
  }
  const seg = (row.slug && row.slug.trim()) || row.doc_id;
  return `/support/library/${seg}`;
}

export function pathForDoc(
  docId: string,
  map: Record<string, DocPathInfo> | null,
): string | null {
  if (docId === "FAQ-000") return "/support/library/dictionary";
  if (!map) return `/support/library/${docId}`;
  const info = map[docId];
  if (!info) return null;
  return docHref({ doc_id: docId, collection: info.collection, slug: info.slug });
}
